export const calcYearlyFee = (fee: number): number => {
  // if (fee > 0) {
  //   console.log("calcYearlyFee", fee);
  // }

  const taxaAnual = Math.pow(1 + fee, 12) - 1;
  return taxaAnual || 0;
};
